import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=ede33472&"
import script from "./TaskTypes.vue?vue&type=script&lang=js&"
export * from "./TaskTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports